import Service from './components/service/service';

import './style.scss';

function getUrlParams() {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const page = urlParams.get('page');
	return page;
}

function App() {
	var url = getUrlParams();
	return (
		<div className="App">
			{/* ?page=serviceupdate */}
			{url === 'serviceupdate' && (
				<Service />
			)}
		</div>
	);
}

export default App;